/** */
import {
  ADD_MANY_PAYMENTS_TO_STORE,
  ADD_ONE_PAYMENT_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_PAYMENTS_TO_STORE,
  REM_ONE_PAYMENT_FROM_STORE
} from '../actions/payment';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_PAYMENTS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (payments, payment) => ({
            ...payments,
            [payment.id]: payment
          }),
          {}
        )
      };
    case ADD_ONE_PAYMENT_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (payments, payment) => ({
            ...payments,
            [payment.id]: payment
          }),
          {}
        )
      };
    case LOAD_PAYMENTS_TO_STORE:
      return {
        ...payload.reduce(
          (payments, payment) => ({
            ...payments,
            [payment.id]: payment
          }),
          {}
        )
      };
    case REM_ONE_PAYMENT_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
